import { render } from "./alternative-device-details.vue?vue&type=template&id=4e88353c&scoped=true"
import script from "./alternative-device-details.vue?vue&type=script&lang=js"
export * from "./alternative-device-details.vue?vue&type=script&lang=js"

import "./alternative-device-details.vue?vue&type=style&index=0&id=4e88353c&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e88353c"]])

export default __exports__